import styled from 'styled-components'

export const AuthorName = styled.strong`
  transition: 0.2s color;

  &:hover {
    color: var(--blue) !important;
    text-decoration: underline;
  }
`

AuthorName.displayName = 'AuthorName'

export const ModerationWrapper = styled.div`
  position: relative;

  &::before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: var(--gray-400);
    display: block;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`

ModerationWrapper.displayName = 'ModerationWrapper'

export const CommentContent = styled.div`
  width: calc(100% - 3.125rem);
`

CommentContent.displayName = 'CommentContent'

export const CommentText = styled.p`
  overflow-wrap: anywhere;

  a {
    color: var(--blue) !important;

    &:hover {
      text-decoration: underline !important;
    }
  }
`

CommentText.displayName = 'CommentText'
